"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));

var _TextField = _interopRequireDefault(require("@jobmatchme/ui/es/components/TextField"));

var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _LockOutlined = _interopRequireDefault(require("@material-ui/icons/LockOutlined"));

var _ie11Check = require("@jobmatchme/utils/es/ie11Check");

var _Lock = _interopRequireDefault(require("@material-ui/icons/Lock"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var PasswordField = function PasswordField(_ref) {
  var togglePassword = _ref.togglePassword,
      name = _ref.name,
      onClick = _ref.onClick,
      onMouseDown = _ref.onMouseDown,
      inputRef = _ref.inputRef,
      inputProps = _ref.inputProps,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$filledIcon = _ref.filledIcon,
      filledIcon = _ref$filledIcon === void 0 ? false : _ref$filledIcon;

  var GetIcon = function GetIcon() {
    return filledIcon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Lock.default, {
      className: "".concat(_styleModule.default.icon, " ").concat(_ie11Check.isIE11 ? _styleModule.default.ie11 : '')
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_LockOutlined.default, {
      className: "".concat(_styleModule.default.icon, " ").concat(_ie11Check.isIE11 ? _styleModule.default.ie11 : '')
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: "".concat(_styleModule.default.passwordWrapper, " ").concat(inline ? _styleModule.default.inline : ''),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: _styleModule.default.showIcon,
        "aria-label": "toggle password visibility",
        onClick: onClick,
        onMouseDown: onMouseDown,
        children: togglePassword ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Visibility.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_VisibilityOff.default, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
        type: togglePassword ? 'text' : 'password',
        name: name,
        placeholder: placeholder,
        bsSize: "lg",
        fullWidth: true,
        defaultInput: true,
        inputRef: inputRef,
        inputProps: inputProps,
        customSize: "medium",
        onChange: onChange,
        startAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
          position: "start",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(GetIcon, {})
        })
      })]
    })
  });
};

var _default = PasswordField;
exports.default = _default;